import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

import { Salary } from "./schema";

import { DataTableColumnHeader } from "./data-table-column-header";
import { DataTableRowActions } from "./data-table-row-actions";
import { Badge } from "@/components/ui/badge/badge";
import { cn } from "@/lib/utils";
// import { convertUTCtoISTWithMinus } from "@/utils";
// import { DataTableRowActions } from "./data-table-row-actions";
// import { DataTableRowActions } from "./data-table-row-actions";

export function getColumns(): ColumnDef<Salary>[] {
  return [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Index" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex flex-col gap-1">
            <span>{row.index + 1}</span>
            {row.original.createdAt && (
              <div>
                ( Created at -{" "}
                {format(new Date(row.original.createdAt), "PPpp")} )
              </div>
            )}
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "notes",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Notes" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("notes")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },

    {
      accessorKey: "totalEarnings",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Total Earnings" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("totalEarnings")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "totalDeductions",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Total Deductions" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("totalDeductions")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "netPay",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Net Pay" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("netPay")}
            </span>
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "approved",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Status" />
      ),
      cell: ({ row }) => {
        const status = row.getValue("approved") as boolean;
        return (
          <div className="flex space-x-2">
            <Badge className={cn(status ? "bg-emerald-500" : "")}>
              {row.getValue("approved") === true ? "Approved" : "Not Approved"}
            </Badge>
          </div>
        );
      },
      enableSorting: false,
    },

    {
      id: "actions",
      cell: ({ row }) => <DataTableRowActions row={row} />,
    },
  ];
}
